import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import Slider from "react-slick";

// Import Images
import img1 from "../assets/images/portfolio/carabinieri.png";
import img2 from "../assets/images/portfolio/prefettura_latina.jpg";
import img3 from "../assets/images/portfolio/biolatina.png";
import img4 from "../assets/images/portfolio/farla.png";
import img5 from "../assets/images/portfolio/conad-logo.svg";
import img6 from "../assets/images/portfolio/conad-logo.svg";
import img7 from "../assets/images/portfolio/carrefour.svg";
import img8 from "../assets/images/portfolio/ortolanda.jpg";
import img9 from "../assets/images/portfolio/farla.png";
import img10 from "../assets/images/portfolio/diocesi.png";
import img11 from "../assets/images/portfolio/ecofarm.png";
import img12 from "../assets/images/portfolio/farla.png";

const GalleryData = [
  {
    image: img1,
    title: "CARABINIERI DELLA PROVINCIA",
  },
  {
    image: img2,
    title: "PREFETTURA DI LATINA",
  },
  {
    image: img3,
    title: "BIOLATINA",
  },
  {
    image: img4,
    title: "FARLA SOC. COOP.",
  },
  {
    image: img6,
    title: "CONAD",
  },
  {
    image: img7,
    title: "CARREFOUR",
  },
  {
    image: img8,
    title: "ORTOLANDA",
  },
  {
    image: img10,
    title: "CURIA VESCOVILE LATINA",
  },
  {
    image: img11,
    title: "ECOFARM",
  },
];

const Portfolio = () => {
  const [photoIndex, setphotoIndex] = useState(0);
  const [isOpen, setisOpen] = useState(false);
  const images = [img1];

  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
      <button className={className} onClick={onClick}>
        <i className="las la-arrow-right" />
      </button>
    );
  }

  function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
      <button className={className} onClick={onClick}>
        <i className="las la-arrow-left"></i>
      </button>
    );
  }

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  };

  return (
    <React.Fragment>
      <section className="section" id="portfolio">
        <Container fluid={true}>
          <Row className="justify-content-center">
            <Col lg={7}>
              <div className="header-title text-center">
                <h3 className="fs-1">Portfolio Clienti</h3>
                <div className="title-border mt-3"></div>
                <p className="title-desc text-muted mt-3 fs-2">
                  Lavoriamo con vari clienti a livello statale e privato
                </p>
              </div>
            </Col>
          </Row>
        </Container>
        <Container className="mt-5" fluid={true}>
          <Row className="g-2 justify-content-center align-items-center padding-y-50" id="grid" style={{ padding: "20px" }}>
            <div className="popular-slider arrow-style row gy-4 align-items-center justify-content-center">
              <Slider {...settings}>
                {GalleryData.map(({ title, image }, key) => (
                  <div key={key} className="col-4 text-center d-flex align-items-center justify-content-center portfolio-box" style={{ height: '200px' }}>
                    <img style={{ maxWidth: "50%", maxHeight: "50%", objectFit: 'cover' }} src={image} alt="work-img" />
                    <div className="portfolio-content">
                      <div className="img-view">
                        <div className="gallery-overlay"></div>
                      </div>
                      <div className="portfolio-caption">
                        <Link className="text-primary">
                          <h5 className="mb-1 fs-15">{title}</h5>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Portfolio;
